<template>
  <ul class="media-list">
    <li
      class="media"
      v-for="strategy in strategies"
      :key="strategy.uuid">
      <div class="media-left">
        <IKImageS3Wrapper
          class="media-object thumbnail"
          v-if="strategy.image_url"
          :aws-url="strategy.image_url"
          alt=""
          :transformation="[{w: 64, q: 80}]"
        />
      </div>
      <div class="media-body">
        <router-link :to="{name: 'StrategyDetailPage', params: {slugOrUuid: strategy.slug}}" target="_blank">
          <h3 class="media-heading">
            <span>{{ strategy.title }}</span> <OpensInNewTabIcon />
          </h3>
        </router-link>
        <WikiText :text="strategy.description | truncateString(140)" :plaintext="true" />
      </div>
    </li>
  </ul>
</template>

<script>
import IKImageS3Wrapper from '@/imagekit/IKImageS3Wrapper'
import WikiText from '@/components/WikiText'
import OpensInNewTabIcon from '../OpensInNewTabIcon.vue';

export default {
  name: 'StrategyMediaList',
  components: {
    WikiText,
    IKImageS3Wrapper,
    OpensInNewTabIcon
  },
  props: {
    strategies: {
      type: Array,
      required: true,
      validator(val) {
        return val.every(strategy => strategy.slug && strategy.uuid)
      }
    }
  }
}
</script>

<style scoped>
.thumbnail {
  width: 74px;
}
</style>
